<template>
    <v-card
        class="pb-5"
        :width="widthProp"
        elevation="0"
        style="border-radius: 10px"
        v-if="this.stepActive == 5 || showSectionCondition"
    >
        <v-card-text>
            <v-form
                v-model="student_other_detail"
                ref="form"
                :disabled="disabledRules"
            >
                <div class="mt-5 mb-4 prompt-title">
                    {{ $t("message.form.topics.healthInformation") }}
                </div>
                <v-row>
                    <v-col cols="12" sm="6" md="3" class="py-0 my-1">
                        <div class="py-1 form-label" hide-details="auto">
                            {{ $t("message.form.healthData.weight") }}
                        </div>
                        <v-text-field
                            dense
                            outlined
                            hide-details="auto"
                            placeholder="0"
                            v-mask="'###'"
                            v-model="weight"
                            :suffix="$t(kg)"
                        ></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="6" md="3" class="py-0 my-1">
                        <div class="py-1 form-label" hide-details="auto">
                            {{ $t("message.form.healthData.height") }}
                        </div>
                        <v-text-field
                            dense
                            outlined
                            hide-details="auto"
                            placeholder="0"
                            v-mask="'###'"
                            v-model="height"
                            :suffix="$t(cm)"
                        ></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="6" md="3" class="py-0 my-1">
                        <div class="py-1 form-label" hide-details="auto">
                            {{ $t("message.form.healthData.bloodType") }}
                        </div>
                        <v-select
                            dense
                            outlined
                            hide-details="auto"
                            v-bind:placeholder="
                                $t('message.form.healthData.fillBloodType')
                            "
                            :items="blood_types"
                            v-model="blood_type"
                        ></v-select>
                    </v-col>
                    <template v-if="from == 'candidates'">
                        <v-col cols="12" sm="6" md="6" class="py-0 my-1">
                            <div class="py-1 form-label" hide-details="auto">
                                {{
                                    $t(
                                        "message.form.healthData.medicalCondition"
                                    )
                                }}
                            </div>
                            <v-textarea
                                dense
                                outlined
                                hide-details="auto"
                                v-bind:placeholder="
                                    $t(
                                        'message.form.healthData.fillMedicalCondition'
                                    )
                                "
                                v-model="medical_condition"
                            ></v-textarea>
                        </v-col>

                        <v-col cols="12" sm="6" md="6" class="py-0 my-1">
                            <div class="py-1 form-label" hide-details="auto">
                                {{ $t("message.form.healthData.drugAllergy") }}
                            </div>
                            <v-textarea
                                dense
                                outlined
                                hide-details="auto"
                                v-bind:placeholder="
                                    $t(
                                        'message.form.healthData.fillDrugAllergy'
                                    )
                                "
                                v-model="drug_allergy"
                            ></v-textarea>
                        </v-col>

                        <v-col cols="12" sm="6" md="6" class="py-0 my-1">
                            <div class="py-1 form-label" hide-details="auto">
                                {{
                                    $t(
                                        "message.form.healthData.regularMedications"
                                    )
                                }}
                            </div>
                            <v-textarea
                                dense
                                outlined
                                hide-details="auto"
                                v-bind:placeholder="
                                    $t(
                                        'message.form.healthData.fillRegularMedications'
                                    )
                                "
                                v-model="regular_medication"
                            ></v-textarea>
                        </v-col>
                        <v-col cols="12" sm="6" md="6" class="py-0 my-1">
                            <div class="py-1 form-label" hide-details="auto">
                                {{$t('message.form.healthData.remark')}}
                            </div>
                            <v-textarea
                                dense
                                outlined
                                hide-details="auto"
                                :placeholder="$t('message.form.healthData.fillRemark')"
                                v-model="note"
                            ></v-textarea>
                        </v-col>
                    </template>
                    <template v-else>
                        <v-col cols="12" sm="6" md="12" class="py-0 my-1">
                            <div class="py-1 form-label" hide-details="auto">
                                {{
                                    $t(
                                        "message.form.healthData.medicalCondition"
                                    )
                                }}
                            </div>
                            <v-text-field
                                dense
                                outlined
                                hide-details="auto"
                                v-bind:placeholder="
                                    $t(
                                        'message.form.healthData.fillMedicalCondition'
                                    )
                                "
                                v-model="medical_condition"
                            ></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="6" md="12" class="py-0 my-1">
                            <div class="py-1 form-label" hide-details="auto">
                                {{ $t("message.form.healthData.drugAllergy") }}
                            </div>
                            <v-text-field
                                dense
                                outlined
                                hide-details="auto"
                                v-bind:placeholder="
                                    $t(
                                        'message.form.healthData.fillDrugAllergy'
                                    )
                                "
                                v-model="drug_allergy"
                            ></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="6" md="12" class="py-0 my-1">
                            <div class="py-1 form-label" hide-details="auto">
                                {{
                                    $t(
                                        "message.form.healthData.regularMedications"
                                    )
                                }}
                            </div>
                            <v-text-field
                                dense
                                outlined
                                hide-details="auto"
                                v-bind:placeholder="
                                    $t(
                                        'message.form.healthData.fillRegularMedications'
                                    )
                                "
                                v-model="regular_medication"
                            ></v-text-field>
                        </v-col>
                    </template>
                </v-row>
            </v-form>
        </v-card-text>
    </v-card>
</template>

<script>
import * as services from "@/services";

export default {
    name: "StudentHealth",
    data: () => ({
        student_other_detail: false,
        weight: "",
        height: "",
        blood_types: ["A", "B", "AB", "O"],
        blood_type: "",
        medical_condition: "",
        drug_allergy: "",
        regular_medication: "",
        note: "",
        kg: "message.form.healthData.kg",
        cm: "message.form.healthData.cm",
    }),
    methods: {
        validate() {
            let payload = {
                weight: this.weight,
                height: this.height,
                blood_type: this.blood_type,
                medical_condition: this.medical_condition,
                drug_allergy: this.drug_allergy,
                regular_medication: this.regular_medication,
            };
            this.$emit("sendData", payload);
        },
        async fetchInitData() {
            try {
                this.$emit("loadingUpdate", 1);
                const body = {
                    query: {
                        selects: {
                            id: true,
                            student_other_detail: {
                                id: true,
                                weight: true,
                                height: true,
                                blood_type: true,
                                medical_condition: true,
                                drug_allergy: true,
                                regular_medication: true,
                                notation: true,
                            },
                        },
                        relations: {
                            student_other_detail: true,
                        },
                    },
                };
                if (this.from == "candidates") {
                    body["id"] = this.applicantId;
                    const {
                        data: { data },
                    } = await services.getStudentWithQuery(body);
                    this.autoFillDataFromDb(data?.student?.student_other_detail);
                }
            } finally {
                this.$emit("loadingUpdate", -1);
            }
        },
        autoFillDataFromDb(data) {
            try {
                this.$emit("loadingUpdate", 1);
                Object.keys(data).forEach(async (key) => {
                    this[key] = data[key];
                    
                });
            } finally {
                this.$emit("loadingUpdate", -1);
            }
        },
    },
    props: {
        checkValidate: Boolean,
        stepActive: Number,
        applicantId: Number,
        widthProp: {
            default: "690",
            type: String,
        },
        registrationState: {
            default: "all",
            type: String,
        },
        from: {
            default: "all",
            type: String,
        },
    },
    emits: ["sendData"],
    computed: {
        disabledRules() {
            if (this.stepActive == 5 && this.$route.query.action == "view")
                return true;
            return false;
        },
        showSectionCondition() {
            try {
                let allow_state = [
                    "SUCCESSFUL_CONFIRMATION_DETAIL",
                    "SUCCESSFUL_ENROLLMENT",
                ];
                if (this.from == "all") return false;
                if (
                    this.from == "candidates" &&
                    allow_state.includes(this.registrationState)
                )
                    return true;
                return false;
            } catch (error) {
                return false;
            }
        },
    },
    watch: {
        checkValidate: function () {
            // watch it
            this.validate();
        },
    },
    updated() {
        this.validate();
    },
    mounted() {
        if (this.stepActive == 5 || this.from == "candidates") {
            this.fetchInitData();
        }
    },
};
</script>

<style scoped>
.form-label{
    font-size: 18px;
}
</style>
